import { domScheduler } from "@studiometa/js-toolkit/utils";
import Switcher from "./Switcher.js";
import { setTheme, getTheme } from "../store/index.js";
class ThemeSwitcher extends Switcher {
  static config = {
    name: "ThemeSwitcher"
  };
  mounted() {
    domScheduler.read(() => {
      const value = getTheme();
      const input = this.$refs.inputs.find((i) => i.value === value);
      domScheduler.write(() => {
        if (input) {
          input.checked = true;
        }
      });
    });
  }
  switch(value) {
    setTheme(value);
  }
}
export {
  ThemeSwitcher as default
};
//# sourceMappingURL=ThemeSwitcher.js.map
